var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteHouseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7603 1.80042V3.86322L12.6003 2.17842V1.80042H14.7603ZM17.5647 7.42362C17.4927 7.51362 17.3883 7.56042 17.2803 7.56042C17.2011 7.56042 17.1255 7.53522 17.0571 7.48482L16.5603 7.09602V16.5604C16.5603 16.7584 16.3983 16.9204 16.2003 16.9204H11.1603V10.4404H6.84034V16.9204H1.80034C1.60234 16.9204 1.44034 16.7584 1.44034 16.5604V7.09602L0.943539 7.48482C0.785139 7.60722 0.558339 7.57842 0.435939 7.42362C0.313539 7.26522 0.342339 7.03842 0.497139 6.91602L8.77714 0.454018C8.91034 0.353218 9.09034 0.353218 9.22354 0.454018L17.5035 6.91602C17.6583 7.03842 17.6871 7.26522 17.5647 7.42362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHouseIcon);
export default __webpack_public_path__ + "static/media/white_house_icon.585f84924df924d2819dae951e861eb2.svg";
export { ForwardRef as ReactComponent };